import React, { useEffect, useRef, useState } from 'react'
import './Header.css'
import img_nav from '../../../img/nav.png'
import img_close from '../../../img/close.png'
import img_search from '../../../img/search.png'

export default function Header({setNav}) {
  const [search,setSearch] = useState(false);

  const iptRef = useRef();

  const goSearch = (e) => {
    let keycode = e.keyCode;
    if (keycode == "13" && iptRef.current.value != "") {
      /* window.location = "/page/search" + "?words=" + iptRef.current.value
      getdata("?words=" + iptRef.current.value) */
    }
  }

  const setSr = () => {
    if(iptRef.current.value.length > 0) iptRef.current.value = ''
    search ? setSearch(false) : setSearch(true) ;
  }

  useEffect(() => {
    
  },[])

  return (
    <header className='header'>
      <img src={img_nav} alt="" className='head_nav' onClick={setNav} />

      <p>
        <span>R</span>andomHow
      </p>

      {/* <div className={search ? 'head_sr head_sred' : 'head_sr'} >
        <input type="search" placeholder={search ? 'Search randomHow' : ''} ref={iptRef} onClick={() => setSearch(true)}/>
        <img src={search ? img_close : img_search} alt="" className='sr_btn' onClick={setSr} />
        {search ? <img src={img_search} alt="" className='sred_icon' onClick={goSearch} />: '' }
      </div> */}
    </header>
  )
}